import React, { useEffect } from 'react';

import { Scrollbar } from '@/components/Scrollbar';
import { Logo } from '@/components/shared/Logo';
import { useStatusBar } from '@/hooks/useStatusBar';
import constants from '@/theme/exportedVariables.module.scss';
import { IonPage } from '@ionic/react';

import styles from './PublicCopilotLayout.module.scss';

interface IProps {
	header?: JSX.Element | boolean;
	footer?: JSX.Element | boolean;
}

const PublicCopilotLayout: React.FC<IProps> & {
	SplitScreen: React.FC<SplitScreenProps>;
} = ({ children, header, footer }) => {
	return (
		<div className={styles['root']}>
			{header && <div className={styles['header']}>{header}</div>}
			<div className={styles['body']}>{children}</div>
			{footer && <div className={styles['footer']}>{footer}</div>}
		</div>
	);
};

interface SplitScreenProps {
	top: JSX.Element;
	bottom: JSX.Element;
}

const SplitScreen: React.FC<SplitScreenProps> = ({ top, bottom }) => {
	return (
		<div className={styles['split-root']}>
			<div className={styles['top']}>{top}</div>
			<div className={styles['bottom']}>{bottom}</div>
		</div>
	);
};

PublicCopilotLayout.SplitScreen = SplitScreen;

export default PublicCopilotLayout;
